import { MainNavProps } from "../navigation/main/MainParamList";
import { useEffect, useState } from "react";
import { ChartMessageItem, MessageType } from "../../constants/types";
import {
  ActivityIndicator,
  FlatList,
  Image,
  Pressable,
  Text,
  View,
  Platform,
  Modal,
} from "react-native";
import { Div } from "./ChatSearch";
import { LeftView } from "./CListItem";
import { getUserName } from "./chat-helper";
import {
  black,
  color_333333,
  color_666666,
  color_main,
  white,
} from "../../assets/style/colors";
import { beforeDatePlus, getAvatarByUser } from "../../utils/utils";
import * as ImSdk from "../../../imsdk/api";
import { fix_msgs_user } from "../../store/ChatStore";
import { MsgSearchCond } from "../../../imsdk/db/t_msg";
import {
  Str_AccordingTo,
  Str_ChatRecord,
	Str_Date,
  Str_File,
  Str_Find,
  Str_Img,
  Str_Member,
  Str_NoData,
	Str_RtcAudio,
	Str_RtcVideo,
  Str_Video,
  Str_Voice,
} from "../../language/string_res";
import { hideLoading, showLoading } from "../../components/Loading";
import FastImage from "react-native-fast-image";
import { useWindowDimensions } from "react-native";
import Video from "react-native-video";
import { VoiceContentRender } from "./components/VoiceContentRender";
import { TextContentRender } from "./components/TextRender";
import { ScreenCloseModal } from "../../components/ScreenModal";
import { ImagePreviewModal } from "../../components/ImagePreviewModal";
import { fixRemoteUrl } from "../../../imsdk/api";
import { DocumentRender } from "./components/DocumentRender";
import { showToast } from "../../components/Toast";

let page = 0;
let hasMore = true;
export const QuickSearchMsgScreen = ({
  navigation,
  route,
}: MainNavProps<"QuickSearchMsgScreen">) => {
  const { width: screenWidth, height: screenHeight } = useWindowDimensions();
  // Web上显示更多列，移动端保持4列
  const columns = Platform.OS === "web" ? 8 : 4; // Web上增加到8列，图片更小
  const imgWidth =
    Platform.OS === "web"
      ? (Math.min(screenWidth, 1000) - 120) / columns // Web上更小的尺寸，增加边距
      : (screenWidth - 40) / 4;
  // 设置最小高度，确保图片和视频不会太小
  const minImgHeight = Platform.OS === "web" ? 120 : 100;
  const { tid, type, sender, date } = route.params;
  const [message, setMessage] = useState<ChartMessageItem[]>();
  const [isLoading, setIsLoading] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [previewItems, setPreviewItems] = useState<ChartMessageItem[]>([]);
  const im = ImSdk.getInstance();

  useEffect(() => {
    page = 0;
    hasMore = true;
    fetchData();
  }, []);

  const fetchData = (isLoad: boolean = false) => {
    if (!isLoad) {
      showLoading();
    }
    setIsLoading(true);
	  let msgType = type;
	  if (type === MessageType.LOCAL_TIME) {
		  msgType = undefined
	  }
	  const cond: MsgSearchCond = { tid: tid, page: page, type: msgType ? [msgType] : [], sender: sender, date: date, mask: 0 };

    im.SearchMsg(cond)
      .then((res) => {
        hideLoading();
        hasMore = res.msgs?.length === 50;
        if (res.msgs && res.msgs.length > 0) {
          const msgs = res.msgs as ChartMessageItem[];
          const fmsgs = msgs.filter(
            (value) => value.type !== MessageType.SYSTEM
          );
          fix_msgs_user(tid, fmsgs).then(() => {
            if (isLoad) {
              const m = message ?? [];
              m.push(...fmsgs);
              setMessage(m);
            } else {
              setMessage(fmsgs);
            }
          });
          setIsEmpty(false);
        } else {
          if (!isLoad) {
            setMessage([]);
            setIsEmpty(true);
          }
        }
      })
      .finally(() => {
        setIsLoading(false);
        hideLoading();
      });
  };

  function loadMore() {
    if (message && message.length > 0 && !isLoading && hasMore) {
      ++page;
      fetchData(true);
    }
  }

  const ItemSeparatorComponent = () => {
    if (type === MessageType.IMAGE || type === MessageType.VIDEO || type === MessageType.DOCUMENT) {
      return <View style={{ height: 8 }} />;
    } else {
      return <Div />;
    }
  };
  const openPreview = (item: ChartMessageItem) => {
    // 获取所有图片或视频
    const allItems =
      message?.filter(
        (msg) =>
          (type === MessageType.IMAGE && msg.type === MessageType.IMAGE) ||
          (type === MessageType.VIDEO && msg.type === MessageType.VIDEO)
      ) || [];

    const index = allItems.findIndex((msg) => msg.mid === item.mid);
    setPreviewItems(allItems);
    setPreviewIndex(index >= 0 ? index : 0);
    setPreviewVisible(true);
  };

  const downloadFile = async (item: ChartMessageItem) => {
    const localPath = item.upload_path ?? '';
    const remoteUrl = item.content;
    const url = fixRemoteUrl(remoteUrl) || localPath;
    const fileName = item.meta?.fileName || '未知文件';

    if (!url) {
      showToast('文件不可用');
      return;
    }

    try {
      // 增加超时控制
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000); // 30秒超时

      const res = await fetch(url, { signal: controller.signal, method: 'GET' });
      clearTimeout(timeoutId);
      if (!res.ok) throw new Error(`下载失败：${res.status}`);

      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = fileName;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      showToast(`✅ ${fileName} 下载完成`);
      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    } catch (e) {
      const errorMsg = e instanceof Error ? e.message : '下载失败';
      showToast(`❌ ${errorMsg}`);
    }
  };

  const ImageItem = ({ item }: { item: ChartMessageItem }) => {
    const itemHeight = Math.max(imgWidth, minImgHeight);
    return (
      <Pressable
        onPress={() => openPreview(item)}
        style={[
          {
            flexDirection: "row",
            marginTop: Platform.OS === "web" ? 8 : 20,
            marginHorizontal: Platform.OS === "web" ? 4 : 0,
            width: imgWidth,
            minHeight: itemHeight,
          },
        ]}
      >
        {Platform.OS !== "web" && <View style={{ width: 4 }} />}
        <FastImage
          style={{
            width: imgWidth,
            height: itemHeight,
            minWidth: imgWidth,
            minHeight: itemHeight,
            borderRadius: Platform.OS === "web" ? 8 : 0,
          }}
          source={{ uri: fixRemoteUrl(item.content) }}
        />
        {Platform.OS !== "web" && <View style={{ width: 4 }} />}
      </Pressable>
    );
  };

  const VideoItem = ({ item }: { item: ChartMessageItem }) => {
    const itemHeight = Math.max(imgWidth, minImgHeight);
    return (
      <Pressable
        onPress={() => openPreview(item)}
        style={{
          alignItems: "center",
          justifyContent: "center",
          marginTop: Platform.OS === "web" ? 8 : 20,
          marginHorizontal: Platform.OS === "web" ? 4 : 0,
          position: "relative",
          width: imgWidth,
          height: itemHeight,
          minHeight: itemHeight,
        }}
      >
        {Platform.OS !== "web" && <View style={{ width: 4 }} />}
        <Video
          style={{
            width: imgWidth,
            height: itemHeight,
            borderRadius: Platform.OS === "web" ? 8 : 0,
            minWidth: imgWidth,
            minHeight: itemHeight,
          }}
          paused={true}
          bufferConfig={{ cacheSizeMB: 20 }}
          source={{ uri: ImSdk.fixRemoteUrl(item.content) }}
          resizeMode="cover"
        />
        {Platform.OS !== "web" && <View style={{ width: 4 }} />}
        <Image
          style={{
            position: "absolute",
            width: Platform.OS === "web" ? 24 : 30,
            height: Platform.OS === "web" ? 24 : 30,
            zIndex: 1,
          }}
          source={require("../../assets/image/icon_play.png")}
        />
      </Pressable>
    );
  };

  const VoiceItem = ({ item }: { item: ChartMessageItem }) => {
    return (
      <View
        style={{
          flexDirection: "row",
          minHeight: Platform.OS === "web" ? 50 : 44,
        }}
      >
        <View
          style={{
            borderRadius: 10,
            marginTop: Platform.OS === "web" ? 8 : 6,
            flexDirection: "row-reverse",
            backgroundColor: "#C4CCDC",
            minHeight: Platform.OS === "web" ? 40 : 36,
            alignSelf: "flex-start",
          }}
        >
          <VoiceContentRender
            item={item}
            isSelf={false}
            styles={{
              color: color_333333,
              paddingHorizontal: Platform.OS === "web" ? 16 : 12,
              paddingVertical: Platform.OS === "web" ? 14 : 10,
            }}
          />
        </View>
      </View>
    );
  };

  const TextItem = ({ item }: { item: ChartMessageItem }) => {
    const textStyle = {
      color: color_333333,
      fontSize: 16,
      marginHorizontal: 12,
    };
    switch (item.type) {
      case MessageType.TEXT:
        return <TextContentRender isSelf={false} item={item} />;
      case MessageType.VOICE:
        return <Text style={textStyle}>[{Str_Voice}]</Text>;
      case MessageType.VIDEO:
        return <Text style={textStyle}>[{Str_Video}]</Text>;
      case MessageType.IMAGE:
        return <Text style={textStyle}>[{Str_Img}]</Text>;
      case MessageType.TALK:
        return <Text style={textStyle}>[{Str_ChatRecord}]</Text>;
		case MessageType.RTC_VOICE:
			return <Text style={textStyle}>[{Str_RtcAudio}]</Text>;
		case MessageType.RTC_VIDEO:
			return <Text style={textStyle}>[{Str_RtcVideo}]</Text>;
      case MessageType.DOCUMENT:
        return <Text style={textStyle}>[{Str_File}]</Text>;

      default:
        return <Text style={textStyle}>{item.content}</Text>;
    }
  };
  const renderItem = ({ item }: { item: ChartMessageItem }) => {
    if (type === MessageType.IMAGE) {
      return <ImageItem item={item} />;
    }
    if (type === MessageType.VIDEO) {
      return <VideoItem item={item} />;
    }

    if (type === MessageType.DOCUMENT) {
      return (
        <DocumentRender
          item={item}
          isSelf={false}
          isTalk={true}
        />
      );
    }
    return (
      <View
        style={{
          flexDirection: "row",
          alignItems: "flex-start",
          paddingStart: 12,
          justifyContent: "center",
          paddingVertical: Platform.OS === "web" ? 20 : 16,
          minHeight: Platform.OS === "web" ? 80 : 70,
        }}
      >
        {item.user ? <LeftView left={getAvatarByUser(item.user)} size={45} /> : null}
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            minHeight: Platform.OS === "web" ? 60 : 50,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              flex: 1,
              marginHorizontal: 12,
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: Platform.OS === "web" ? 8 : 4,
            }}
          >
            <Text style={{ color: color_666666, fontSize: 14 }}>
              {getUserName(item.user)}
            </Text>
            <Text style={{ color: color_666666, fontSize: 12 }}>
              {beforeDatePlus(item.stime)}
            </Text>
          </View>
          {type === MessageType.VOICE ? (
            <VoiceItem item={item} />
          ) : MessageType.TEXT ? (
            <TextItem item={item} />
          ) : null}
        </View>
      </View>
    );
  };

  // 渲染底部加载提示
  const ListFooterComponent = () => (
    <View style={{ padding: 20, alignItems: "center" }}>
      {isLoading && <ActivityIndicator size="large" color="#0000ff" />}
    </View>
  );
  const ListEmptyComponent = () => {
    if (isEmpty) {
      return (
        <View
          style={{
            flex: 1,
            alignItems: "center",
            marginTop: screenHeight / 3,
          }}
        >
          <Text style={{ color: textColor, fontSize: 16 }}>{Str_NoData}</Text>
        </View>
      );
    }
    return <></>;
  };
  const title = sender
    ? Str_Member
    : type === MessageType.IMAGE
      ? Str_Img
      : type === MessageType.VIDEO
        ? Str_Video
        : type === MessageType.VOICE
          ? Str_Voice
          : type === MessageType.DOCUMENT
            ? Str_File
					  : type === MessageType.LOCAL_TIME
						  ? Str_Date
						  : "";
  const textColor = color_333333;
  const count =
    type === MessageType.IMAGE || type === MessageType.VIDEO ? columns : 1;
  return (
    <ScreenCloseModal title={`${Str_AccordingTo}${title}${Str_Find}`}>
      <FlatList
        data={message}
        style={{
          marginHorizontal: Platform.OS === "web" ? 20 : 4,
          flex: 1,
        }}
        contentContainerStyle={{
          paddingBottom: Platform.OS === "web" ? 20 : 10,
        }}
        keyExtractor={(item) => item.mid}
        ItemSeparatorComponent={ItemSeparatorComponent}
        onEndReached={loadMore}
        onEndReachedThreshold={0.1}
        keyboardDismissMode="on-drag"
        numColumns={count}
        ListEmptyComponent={ListEmptyComponent}
        ListFooterComponent={ListFooterComponent}
        renderItem={renderItem}
      />

      {/* 预览 Modal */}
      <Modal
        visible={previewVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setPreviewVisible(false)}
      >
        <View
          style={{
            flex: 1,
            backgroundColor: "rgba(0, 0, 0, 0.8)", // 80% 黑色透明背景
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* 关闭按钮 */}
          <Pressable
            style={{
              position: "absolute",
              top: Platform.OS === "web" ? 20 : 40,
              right: Platform.OS === "web" ? 20 : 40,
              width: 40,
              height: 40,
              borderRadius: 20,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
            onPress={() => setPreviewVisible(false)}
          >
            <Text style={{ color: white, fontSize: 24, fontWeight: "bold" }}>
              ×
            </Text>
          </Pressable>

          {/* 下载按钮 */}
          {Platform.OS === "web" && previewItems[previewIndex] && (
            <Pressable
              style={{
                position: "absolute",
                top: Platform.OS === "web" ? 20 : 40,
                right: Platform.OS === "web" ? 70 : 90,
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
              onPress={() => {
                if (previewItems[previewIndex]) {
                  downloadFile(previewItems[previewIndex]);
                }
              }}
            >
              <Text style={{ color: white, fontSize: 18 }}>↓</Text>
            </Pressable>
          )}

          {/* 预览内容 */}
          {previewItems[previewIndex] && (
            <View
              style={{
                width: "90%",
                maxWidth: 800,
                height: "80%",
                maxHeight: "80%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {previewItems[previewIndex].type === MessageType.VIDEO ? (
                <View
                  style={{
                    width: "100%",
                    aspectRatio: 16 / 9,
                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: 8,
                  }}
                >
                  <Video
                    style={{ width: "100%", height: "100%", borderRadius: 8 }}
                    source={{
                      uri:
                        previewItems[previewIndex].content ||
                        previewItems[previewIndex].upload_path,
                    }}
                    resizeMode="contain"
                    controls={true}
                  />
                </View>
              ) : (
                <Image
                  source={{
                    uri:
                      previewItems[previewIndex].content ||
                      previewItems[previewIndex].upload_path,
                  }}
                  resizeMode="contain"
                  style={{
                    width: "100%",
                    height: "100%",
                    maxWidth: "100%",
                    maxHeight: "100%",
                    borderRadius: 8,
                  }}
                />
              )}
            </View>
          )}

          {/* 左右切换按钮 */}
          {previewItems.length > 1 && (
            <>
              {previewIndex > 0 && (
                <Pressable
                  style={{
                    position: "absolute",
                    left: 20,
                    width: 50,
                    height: 50,
                    borderRadius: 25,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onPress={() =>
                    setPreviewIndex((prev) => Math.max(0, prev - 1))
                  }
                >
                  <Text
                    style={{ color: white, fontSize: 24, fontWeight: "bold" }}
                  >
                    ‹
                  </Text>
                </Pressable>
              )}
              {previewIndex < previewItems.length - 1 && (
                <Pressable
                  style={{
                    position: "absolute",
                    right: 20,
                    width: 50,
                    height: 50,
                    borderRadius: 25,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onPress={() =>
                    setPreviewIndex((prev) =>
                      Math.min(previewItems.length - 1, prev + 1)
                    )
                  }
                >
                  <Text
                    style={{ color: white, fontSize: 24, fontWeight: "bold" }}
                  >
                    ›
                  </Text>
                </Pressable>
              )}
            </>
          )}

          {/* 页码指示器 */}
          {previewItems.length > 1 && (
            <View
              style={{
                position: "absolute",
                bottom: 40,
                flexDirection: "row",
                gap: 8,
              }}
            >
              {previewItems.map((_, index) => (
                <View
                  key={index}
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: 4,
                    backgroundColor:
                      index === previewIndex
                        ? white
                        : "rgba(255, 255, 255, 0.5)",
                  }}
                />
              ))}
            </View>
          )}
        </View>
      </Modal>
      <ImagePreviewModal
        visible={previewVisible}
        items={previewItems}
        initialIndex={previewIndex}
        onClose={() => setPreviewVisible(false)}
      />
    </ScreenCloseModal>
  );
};
